import { createSlice } from '@reduxjs/toolkit'
import { keyBy, setNestedKey } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { getIdsTable } from '../helper'
import { getSuggestionCompany, getSuggestionCompanyDetail } from './thunk'

const initialState = {
  loading: {
    suggestionCompany: true,
    suggestionDetailCompany: true,
  },
  dataSuggest: {},
  ids: [],
  idsDetails: [],
  idActive: undefined,
  dataDetailsSuggest: {},
}

const slice = createSlice({
  name: 'dashboard/interested',
  initialState: initialState,
  reducers: {
    changeIdActive: (state, action) => {
      state.idActive = action.payload
    },
    changeDetailsSuggest: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state, path, data)
    },
    clearCheckbox: (state) => {
      const dataFormat = {}
      Object.keys(state.dataDetailsSuggest).forEach((item) => {
        dataFormat[item] = { ...state.dataDetailsSuggest[item], check: false }
      })
      state.dataDetailsSuggest = dataFormat
    },
  },
  extraReducers: (builder) => {
    //getSuggestionCompany
    builder.addCase(getSuggestionCompany.pending, (state) => {
      state.loading.suggestionCompany = true
    })
    builder.addCase(getSuggestionCompany.fulfilled, (state, action) => {
      state.ids = getIdsTable(action.payload || [])
      state.dataSuggest = keyBy(action.payload || [], 'portfolioId')
      state.loading.suggestionCompany = false
    })
    builder.addCase(getSuggestionCompany.rejected, (state, action) => {
      state.ids = []
      state.dataSuggest = {}
      state.loading.suggestionCompany = action.payload.loading
    })

    //getSuggestionCompanyDetail
    builder.addCase(getSuggestionCompanyDetail.pending, (state) => {
      state.loading.suggestionDetailCompany = true
    })
    builder.addCase(getSuggestionCompanyDetail.fulfilled, (state, action) => {
      state.dataDetailsSuggest = keyBy(action.payload || [], 'organizationId')
      state.idsDetails = action.payload.map((item) => item?.organizationId)
      state.loading.suggestionDetailCompany = false
    })
    builder.addCase(getSuggestionCompanyDetail.rejected, (state, action) => {
      state.dataDetailsSuggest = initialState.dataDetailsSuggest
      state.idsDetails = initialState.idsDetails
      state.loading.suggestionDetailCompany = action.payload.loading
    })
  },
})

//loading
export const getLoadingInterested = (type) => (state) =>
  state[slice.name].loading[type]

//data suggest
export const selectIdsTable = (state) => state[slice.name].ids
export const selectDataSuggest = (state) => state[slice.name].dataSuggest
export const selectLastUpdatedDate = (state) => {
  const { ids, dataSuggest } = state[slice.name]
  const firstItem = dataSuggest[ids[0]]

  return firstItem?.publicDateId
}
export const getDataTableFromRedux = (rowId, colId) => (state) => {
  if (typeof rowId === 'string') return
  return colId
    ? state[slice.name].dataSuggest[rowId][colId]
    : state[slice.name].dataSuggest[rowId]
}

//data details suggest
export const selectDataDetailSuggest = (state) =>
  state[slice.name].dataDetailsSuggest
export const selectIdActive = (state) => state[slice.name].idActive
export const selectIdsDetail = (state) => state[slice.name].idsDetails
export const getDataFromReduxDetails = (rowId, colId) => (state) =>
  state[slice.name].dataDetailsSuggest[rowId][colId]
//main
export const selectSuggest =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].dataDetailsSuggest,
    )
    return callback ? callback(data) : data
  }

export const { changeIdActive, changeDetailsSuggest, clearCheckbox } =
  slice.actions

register(slice.name, slice.reducer)
